/**
 * Subscribers table may use `created_at` (common Supabase default) or `subscribed_at`
 * (older docs). Prefer whichever is present for display and analytics.
 */
export function getSubscriberSignedAt(row) {
  if (!row || typeof row !== 'object') return null;
  return row.subscribed_at ?? row.created_at ?? null;
}

/**
 * Column name for `.order()` — default `created_at` when `subscribed_at` does not exist.
 * Set REACT_APP_SUBSCRIBERS_DATE_COLUMN=subscribed_at if your table only has that.
 */
export function getSubscriberOrderColumn() {
  return process.env.REACT_APP_SUBSCRIBERS_DATE_COLUMN || 'created_at';
}
